import { UiTable, UiButton, UiRangePicker } from "../../../../components";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Modal, DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { tablePageSizeOptions } from "../../../../utils/appUtils";
import OfferDrawer from "../couponDrawer/offerDrawer";
import closeIcon from "../../../../assets/images/close.svg";
import "./style.scss";

const OffersHistory = ({
    offersData,
    totalElements,
    filter,
    setFilter,
    columns,
    drawerOpen,
    formData,
    onBack,
    onPagination,
    onOffersSend,
    onDrawerClose,
    onInputChange,
    onSubmit,
    closeOfferModalOpen,
    onCloseOfferConfirm,
    onCloseOfferCancel,
    imageModalOpen,
    selectedImages,
    onImageModalClose,
    previewImage,
    setPreviewImage
}) => {
    useEffect(() => {
        if (selectedImages && selectedImages?.length > 0) {
            setPreviewImage(selectedImages[0]);
        }
    }, [selectedImages, imageModalOpen, setPreviewImage]);

    return (
        <div>
            <div className="flexible">
                <div className="history-header">
                    <ArrowLeftOutlined onClick={onBack} className="back-icon" />
                    <h6 style={{ padding: "10px", margin: 0, whiteSpace: "nowrap" }}>Offers History</h6>
                </div>
                <div className="button-group" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <DatePicker
                        picker="month"
                        format="MMM"
                        placeholder="Select Month"
                        value={filter?.month}
                        onChange={(date) => setFilter(prev => ({ ...prev, month: date, startDate: null, endDate: null, page: 0 }))}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        style={{ height: 32, width: 150, borderRadius: 6 }}
                    />
                    <UiRangePicker
                        placeholder={["Start date", "End date"]}
                        value={filter?.startDate && filter?.endDate ? [dayjs(filter?.startDate), dayjs(filter?.endDate)] : null}
                        onChange={(dates) => setFilter(prev => ({ ...prev, startDate: dates?.[0] || null, endDate: dates?.[1] || null, month: null, page: 0 }))}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        style={{ width: '250px' }}
                    />
                    <UiButton
                        className="offers-send-btn"
                        onClick={onOffersSend}
                    >
                        + Offers Send
                    </UiButton>
                </div>
            </div>
            <UiTable
                columns={columns}
                dataSource={offersData}
                scroll={{ x: "max-content" }}
                pagination={{
                    current: filter?.page + 1,
                    pageSize: filter?.size,
                    total: totalElements,
                    pageSizeOptions: tablePageSizeOptions,
                    showSizeChanger: true,
                    onChange: onPagination
                }}
            />
            <OfferDrawer
                open={drawerOpen}
                formData={formData}
                onClose={onDrawerClose}
                onInputChange={onInputChange}
                onSubmit={onSubmit}
            />
            <Modal
                title={null}
                open={closeOfferModalOpen}
                onCancel={onCloseOfferCancel}
                footer={null}
                centered
                width={400}
                className="delete-confirmation-modal"
            >
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <img src={closeIcon} alt="close-icon" style={{ width: 50, height: 50, marginBottom: 10 }} />
                    <h6>Are You Sure, You Want To Close The Offer ?</h6>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
                        <UiButton onClick={onCloseOfferCancel} style={{ background: "white", color: "#Cfa14e", border: "1px solid #Cfa14e" }}>Cancel</UiButton>
                        <UiButton onClick={onCloseOfferConfirm} style={{ background: "#Cfa14e", color: "white" }}>Confirm</UiButton>
                    </div>
                </div>
            </Modal>
            <Modal
                open={imageModalOpen}
                footer={null}
                onCancel={onImageModalClose}
                centered
                width={500}
                className="custom-image-modal"
                closeIcon={<span style={{ fontSize: 24, background: "#fff", borderRadius: "50%", width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", color: "#000" }}>×</span>}
            >
                <div className="image-gallery-container">
                    <div className="main-image-wrapper">
                        <img src={previewImage} alt="Main Preview" className="main-image" />
                    </div>
                    <div className="thumbnails-wrapper">
                        {selectedImages?.map((img, index) => {
                            if (index < 4) {
                                return (
                                    <div
                                        key={index}
                                        className={`thumbnail-item ${previewImage === img ? 'active' : ''}`}
                                        onClick={() => setPreviewImage(img)}
                                    >
                                        <img src={img} alt={`thumb-${index}`} />
                                        {index === 3 && selectedImages?.length > 4 && (
                                            <div className="more-overlay">
                                                {selectedImages?.length - 4}+
                                            </div>
                                        )}
                                    </div>
                                )
                            }
                            return null;
                        })}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default OffersHistory;
